module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "wide": false,
      "width": "940px"
    },
    on: {
      "close": _vm.localClose
    }
  }, [_c('img', {
    staticClass: "high-five",
    attrs: {
      "src": 'https://static.booking.branasgruppen.se/static/img/bjorn.svg'
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('general.highfive')))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.message)
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.localClose()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.go-to-cart')))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('general.cart-upsell-title')))]), _vm._v(" "), _c('CompletedBookings', {
    staticStyle: {
      "margin-top": "10px"
    }
  }), _vm._v(" "), _c('SkiRentalDiscount', {
    attrs: {
      "click-link": "/skidhyra"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3048d40f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/CartHighFiveModal.vue
// module id = 919
// module chunks = 0